import React from 'react'
import { Container } from '@cleartrip/ct-design-components'
import { IndianFlagIcon, Clock48Icon, PalmTreeIcon } from './icons'
import styles from './VdcEducationPage.module.scss'

const ELIGIBILITY_ICONS = {
  flag: <IndianFlagIcon />,
  palmTree: <PalmTreeIcon/>,
  clock: <Clock48Icon />
} as const

const ELIGIBILITY_CONTENT = [
  {
    icon: 'flag' as const,
    content: <>Only for <strong>Indian<br/>citizens</strong></>
  },
  {
    icon: 'palmTree' as const,
    content: <>Only for <strong>tourist, business<br/>and student visa</strong> holders</>
  },
  {
    icon: 'clock' as const,
    content: <>Claim up to <strong>48 hrs</strong><br/>before <strong>departure</strong></>
  }
]

const Eligibility: React.FC = () => (
  <Container className={`${styles.eligibility} flex`}>
    {ELIGIBILITY_CONTENT.map((item, index) => (
      <React.Fragment key={index}>
        <Container className={`${styles['eligibility__item']} flex flex-column`}>
          <Container className={styles['eligibility__icon']}>{ELIGIBILITY_ICONS[item.icon]}</Container>
          <span className={styles['eligibility__text']}>{item.content}</span>
        </Container>
        {index < ELIGIBILITY_CONTENT.length - 1 && (
          <Container className={styles['eligibility__divider']} />
        )}
      </React.Fragment>
    ))}
  </Container>
)

export default Eligibility

